module.exports = __webpack_public_path__ + "img/rpas_apr_mockup_banner_5.741b731c.png";